module.exports = __webpack_public_path__ + "media/images/items/anim-8-812c1bb2534fe87e08ed6fd00a1cfce9.webp";